import {getClusterMarkerIcon} from '../scripts/libs/markers/get-marker-icons';

/**
 * Exports styles for
 * 1. clusters of works of arts created before and after 1945
 * 2. clusters of works of arts created before 1945
 * 3. clusters of works of arts created after 1945
 */
export const clusterMarkerStyles = [
  getClusterMarkerIcon(null),
  getClusterMarkerIcon(true),
  getClusterMarkerIcon(false)
];
